import SimpleLightbox from 'simplelightbox'

export default function lightbox() {
    const galerieItems = document.querySelectorAll('.v-functions__item--galerie');
    galerieItems.forEach(item => {
        const button = item.querySelectorAll('button');
        if (button) {
            new SimpleLightbox(button, {
                sourceAttr: 'data-lightbox-src'
            });
        }
    });
}


